import styles from './mailing-lists.module.css'

import { LuTrash2 } from '@react-icons/all-files/lu/LuTrash2'
import React from 'react'

import { Button, Flex, Text } from 'components/ds'

type Props = {
  selectedCount: number
  onDelete: () => void
  onClear: () => void
}

/**
 * Floating bulk-actions bar shown over the mailing lists table while two or
 * more rows are selected.
 */
const SelectionActionMenu = ({
  selectedCount,
  onDelete,
  onClear,
}: Props): React.ReactElement => (
  <Flex
    className={styles.SelectionActionMenu}
    align="center"
    gap="4"
    role="toolbar"
    aria-label="Bulk actions"
  >
    <Text size="2" weight="medium">
      {selectedCount} selected
    </Text>
    <Flex gap="2" align="center">
      <Button size="1" variant="soft" color="gray" onClick={onClear}>
        Clear
      </Button>
      <Button size="1" color="red" onClick={onDelete}>
        <LuTrash2 />
        Delete
      </Button>
    </Flex>
  </Flex>
)

export default SelectionActionMenu
